import { GatewayStatus } from 'src/pages/billing/paymentTrafficMonitoring/types'

export const PERIOD_VALUES = {
  LAST_15_MINUTES: 'last_15m',
  LAST_30_MINUTES: 'last_30m',
  LAST_1_HOUR: 'last_1h',
  LAST_12_HOURS: 'last_12h',
  LAST_24_HOURS: 'last_24h',
  DATE_RANGE: 'date_range',
} as const

export const PERIOD_OPTIONS = [
  { label: 'Last 15 minutes', value: PERIOD_VALUES.LAST_15_MINUTES },
  { label: 'Last 30 minutes', value: PERIOD_VALUES.LAST_30_MINUTES },
  { label: 'Last 1 hour', value: PERIOD_VALUES.LAST_1_HOUR },
  { label: 'Last 12 hours', value: PERIOD_VALUES.LAST_12_HOURS },
  { label: 'Last 24 hours', value: PERIOD_VALUES.LAST_24_HOURS },
  { label: 'Date Range', value: PERIOD_VALUES.DATE_RANGE },
]

export const STATUS_OPTIONS = [
  { text: 'healthy', value: 'healthy' },
  { text: 'stable', value: 'stable' },
  { text: 'degraded', value: 'degraded' },
  { text: 'warning', value: 'warning' },
  { text: 'alert', value: 'alert' },
]

export const MapGatewayStatusAntd: Record<GatewayStatus, string> = {
  healthy: 'default',
  stable: 'default',
  degraded: 'var(--color-yellow-40)',
  warning: 'var(--color-orange-50)',
  alert: 'var(--color-red-50)',
}
